export const UrlHelper = {
  getSearchParameter: (key: string) => {
    const search = globalThis.location.search;
    const params = new URLSearchParams(search);
    return params.get(key);
  },
  addSearchParameter: (key: string, value: string) => {
    const search = globalThis.location.search;
    const params = new URLSearchParams(search);
    params.set(key, value);
    return params.toString();
  },
  // Accepts an optional search string to allow batch removals
  deleteSearchParameter: (key: string, searchStr?: string) => {
    const search = searchStr ?? globalThis.location.search;
    const params = new URLSearchParams(search);
    params.delete(key);
    return params.toString();
  },
  createSearchParameter: (key: string, value: string) => {
    const params = new URLSearchParams();
    params.set(key, value);
    return params.toString();
  },
};
